import { cn } from "@lib/cn";
import type { CSSProperties } from "react";

interface IProps {
  noAnim?: boolean;
  style?: CSSProperties;
}

export const StockVideoSkeleton = ({ noAnim, style }: IProps) => {
  return (
    <div
      className={cn(
        "tw-h-full tw-w-full tw-rounded tw-bg-blue-50",
        !noAnim && "tw-animate-skeleton-loading",
      )}
      style={style}
    />
  );
};
